/**
 * Customer Admin Bundle Configuration
 * Routes accessible to CUSTOMER_ADMIN and SYSTEM_ADMIN roles
 */

// Routes a CUSTOMER_ADMIN is allowed to open. SYSTEM_ADMIN inherits this set
// via canAccessBundle. Anything that requires cross-customer visibility
// (global users list, system-wide email templates, audit logs, the admin
// dashboard) belongs in SYSTEM_ADMIN_ROUTES instead — both for correct
// bundle resolution and so Lambda@Edge (see constructs/GatewayConstruct/
// lambdas/jwt-validator.ts) keeps serving the matching asset rules.
export const CUSTOMER_ADMIN_ROUTES = [
    'customer-360',
    'email-logs',
    // Cloud-repository configuration. Replaced the four standalone
    // routes (repositories / repository-rules / repository-activity /
    // pending-files) which are now embedded as sub-pills inside
    // content-repositories.tag and intentionally not reachable on
    // their own — see services/pageLoader.bundle.customer-admin.js.
    // Lambda@Edge gates the customer-admin bundle by asset prefix,
    // not by route name, so adding/removing routes inside an
    // existing bundle doesn't require a jwt-validator update.
    'content-repositories',
    'login-domain',
    'sso',
    // METALARK-928 opened webhook subscriptions to CUSTOMER_ADMIN, and
    // METALARK-929 to PARTNER_ADMIN. It belongs in the customer-admin bundle so
    // non-system admins resolve to a bundle they can load (was previously only in
    // SYSTEM_ADMIN_ROUTES, which denied customer/partner admins at the bundle gate).
    'webhook-subscriptions',
    // METALARK-929: the outbound delivery log, reachable via the "View deliveries"
    // deep-link from a subscription. Backend scopes it to the caller (a partner to
    // its own subscriptions' deliveries; a customer admin to its own customer).
    'webhook-deliveries',
    // METALARK-929: PARTNER_ADMIN portal pages (each self-guards to
    // PARTNER_ADMIN/SYSTEM_ADMIN; nav exposes them only to PARTNER_ADMIN).
    // partner-dashboard is the portal landing; partner-customers is the list.
    'partner-dashboard',
    'partner-customers',
] as const;

export type CustomerAdminRoute = typeof CUSTOMER_ADMIN_ROUTES[number];

export const CUSTOMER_ADMIN_BUNDLE_PATH = '/assets/customer-admin';
export const BUNDLE_NAME = 'customer-admin';
export const REQUIRED_ROLES = ['CUSTOMER_ADMIN', 'SYSTEM_ADMIN'];
